import { useState } from "react";
import './model-tree.css';
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { ModelInModelTreeInProcessEditor } from "../../../utils/create-model-tree-for-porcess-editor-and-set-uuid/create-model-tree-for-porcess-editor-and-set-uuid";

export const hasSelectedChild = (model: ModelInModelTreeInProcessEditor, selectedUUID: string): boolean => {
    if (model.children) {
        for (const childModel of model.children) {
            if (childModel.uuid === selectedUUID) return true;

            const _hasSelectedChild = hasSelectedChild(childModel, selectedUUID);
            if (_hasSelectedChild) return true;
        }
    }
    return false;
};

type ModelTreeItemProps = {
    model: ModelInModelTreeInProcessEditor;
    selectedUUID: string | null;
    onSelect: (uuid: string) => void;
    onSelectWithDoubleClick?: (uuid: string) => void;
};

const ModelTreeItem = ({ model, selectedUUID, onSelect, onSelectWithDoubleClick }: ModelTreeItemProps) => {
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
    const [prevSelectedUUID, setPrevSelectedUUID] = useState<typeof selectedUUID>(null);

    if (prevSelectedUUID !== selectedUUID) {
        setPrevSelectedUUID(selectedUUID);
        if (selectedUUID !== null && hasSelectedChild(model, selectedUUID)) {
            setIsSubMenuOpen(true);
        }
    }

    return (
        <li>
            {
                model?.children && model.children.length > 0 && (
                    <span
                        style={{
                            color: isSubMenuOpen ? 'red' : 'green',
                            fontSize: '20px',
                            fontWeight: 'bold',
                            cursor: 'pointer'
                        }}
                        onClick={() => setIsSubMenuOpen(!isSubMenuOpen)}
                    >
                        { isSubMenuOpen ? '-' : '+' }&nbsp;
                    </span>
                )
            }
            <span>
                { model.visible ? <EyeInvisibleOutlined /> : <EyeOutlined /> }
            </span>
            &nbsp;
            <span
                className={`name ${ selectedUUID === model.uuid ? 'active' : '' }`}
                onClick={() => onSelect(model.uuid)}
                onDoubleClick={() => { if (onSelectWithDoubleClick) onSelectWithDoubleClick(model.uuid); }}
            >
                { model.name }
            </span>
            {
                isSubMenuOpen && model?.children && model.children.length > 0 && (
                    <ul>
                        {
                            model.children.map(_model => (
                                <ModelTreeItem
                                    model={_model}
                                    selectedUUID={selectedUUID}
                                    onSelect={onSelect}
                                    onSelectWithDoubleClick={onSelectWithDoubleClick}
                                    key={_model.uuid}
                                />
                            ))
                        }
                    </ul>
                )
            }
        </li>
    );
};

type ModelTreeProps = {
    models: ModelInModelTreeInProcessEditor[];
    onSelect: (uuid: string) => void;
    onSelectWithDoubleClick?: (uuid: string) => void;
    selectedUUID: string | null;
};

export const ModelTree = ({ models, onSelect, onSelectWithDoubleClick, selectedUUID }: ModelTreeProps) => {
    return (
        <div className='model-tree-in-process-editor'>
            <ul>
                {
                    models.map(model => (
                        <ModelTreeItem
                            key={model.uuid}
                            model={model}
                            selectedUUID={selectedUUID}
                            onSelect={onSelect}
                            onSelectWithDoubleClick={onSelectWithDoubleClick}
                        />
                    ))
                }
            </ul>
        </div>
    );
};